import './styles/main.scss';

import './scripts/cookie-policy.js';


(function($) {
	$(document).ready(function() {

		// ADD required donationplugin fields

		// if the page template is hyllningsgava.php then add the required fields
		if ($(".page-template-hyllningsgava").length) {
			$("#billing_fornamn_hyllningsgava_field").addClass("validate-required");
			$("#billing_effternamn_hyllningsgava_field").addClass("validate-required");
			$("#billing_adress_hyllningsgava_field").addClass("validate-required");
			$("#billing_postnummer_hyllningsgava_field").addClass("validate-required");
			$("#billing_ort_hyllningsgava_field").addClass("validate-required");
			$("#billing_ditt_era_namn_och_eventuell_halsning_hyllningsgava_field").addClass("validate-required");
		}

		// If the template is minnesgava 
		if ($(".page-template-minnesgava").length) {
			$("#billing_till_minne_av_fornamn__field").addClass("validate-required");
			$("#billing_till_minne_av_efternamn_field").addClass("validate-required");
			$("#billing_till_minne_av_halsning_field").addClass("validate-required");
			$("#billing_namn_pa_begravningsbyra_anhorig_field").addClass("validate-required");
			$("#billing_adress_begravningsbyra_anhorig_field").addClass("validate-required");
			$("#billing_postnummer_begravningsbyra_anhorig_field").addClass("validate-required");
			$("#billing_ort_begravningsbyra_anhorig_field").addClass("validate-required");
		}


	




		/* Toggle sub menu in mobile */
		$('.sub-menu-toggle').on('click', (e) => {

			$(e.currentTarget).parent().parent().toggleClass('is-open');
		});

		/* Toggle search overlay */
		$('.toggle-search, .close-search').on('click', () => {
			$('.search-overlay').toggleClass('is-open');
			$('#s').focus();
		});

		/* Show header bg on scroll */
		if ( !$('.site-header').hasClass('has-bg-always') ) {
			$(window).scroll(function() {    
				var scroll = $(window).scrollTop();
				if (scroll >= 30) {
						$(".site-header").addClass("has-bg");
				} else {
						$(".site-header").removeClass("has-bg");
				}
			});
		}

		/* Toggle mobile menu */
		$('.toggle-menu').on('click', function() {
			$('.nav-primary__mobile').toggleClass('is-open');
		});

		/* Click outside of mobile menu closes it as well */
		$(document).on('mouseup', function(e) {
			if ( $('.nav-primary__mobile').hasClass('is-open') && !$('.nav-primary__mobile').is(e.target) && $('.nav-primary__mobile').has(e.target).length === 0) {
				$('.nav-primary__mobile').toggleClass('is-open');
			}
		});

		// add a paralax effect on img with the class the-hero-image
		$(window).scroll(function() {
			// get the scroll position of the page
			var scroll = $(window).scrollTop();

			// add the paralax effect on the hero image not using background image since the object is an img
			$('.the-hero-image').css({
				'transform': 'translate(0px, ' + scroll / 15 + '%)',
				// smooth out transform
				

			});

			
		});


		 
		


		// fade out
		$(window).scroll(function(){
			$(".wp-block-flexig-hero-text").css("opacity", 1 - $(window).scrollTop() / 250);
		  });
		
		   /******************************************************************************\
      SMOOTH SCROLLING 
    \******************************************************************************/
	$('a[href*=#]:not([href=#])').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		  var target = $(this.hash);
		  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		//scroll amount is the same as the height of the hero section
	
		var scrollTotal = 0;
		if ($(".hero").length) {
			scrollTotal = $(".hero").height();
		}

		  // if the target exists
		// do this only if clicked on .mouse_scroll or .mouse_scroll a
		if ($(this).hasClass("mouse_scroll") || $(this).parent().hasClass("mouse_scroll")) {
			if (target.length) {
				$('html,body').animate({
					scrollTop: scrollTotal 					
				}, 1000);
				return false;
			  }		
		}
		if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top - 100					
			}, 1000);
			return false;
		  }	

		
		}
	  });

		
	});
})(jQuery);